//@flow

import classnames from "classnames";
import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import HiddenBruImage from "@/components/HiddenBruImage/HiddenBruImage";
import useCurrentSrcChangeCallback from "@/utils/useCurrentSrcChangeCallback";

type Props = {
    title: React$Node,
    content: React$Node,
    variant: CardVariant,
    link?: string,
    image?: ImageSharp,
    textColor?: string,
    styleClass?: string,
    noTopPadding?: boolean,
};

const Card = (props: Props): React$Element<"a" | "div"> => {
    const [style, setStyle] = useState<any>({});

    const onCurrentSrcChange = useCurrentSrcChangeCallback(setStyle);

    const card = (
        <div
            className={classnames(
                "card",
                props.variant,
                props.image && " hover-zoom-visual",
                props.noTopPadding && "no-top-padding",
            )}
        >
            {props.image ? (
                <div
                    className={`visual h-100 w-100 left top position-absolute ${
                        props.styleClass ? props.styleClass : ""
                    }`}
                    style={style}
                >
                    <HiddenBruImage
                        onCurrentSrcChange={onCurrentSrcChange}
                        image={props.image}
                    />
                </div>
            ) : (
                <></>
            )}
            <Row className={"h-100 align-items-start"}>
                <Col className={"d-flex flex-column h-100"}>
                    <h2
                        className={`h1 mb-0 title line-height-xs ${
                            props.textColor ? props.textColor : ""
                        }`}
                    >
                        {props.title}
                    </h2>
                    <div className="content d-flex flex-column flex-grow-1">
                        {props.content}
                    </div>
                </Col>
            </Row>
        </div>
    );

    if (props.link) {
        return (
            <a href={props.link} className={"continue-link-hover-parent"}>
                {card}
            </a>
        );
    }

    return card;
};

export default Card;
